import { Injectable, inject } from '@angular/core';
import axios from 'axios';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { RedirectService } from '../redirect/redirect.service';
import { UsersService } from '../users/users.service';
import { Router } from '@angular/router';

export type InvoiceMissingReason =
  'invoice-missing-not-exists'
  | 'invoice-missing-invalid-client'
  | 'invoice-missing-invalid-debtor-tax-number'
  | 'invoice-missing-invalid-debtor-key';

export type GetKsziInfoResponse = {
  invoices_recieved: number;
  invoices_pending: number;
  minutes_left: number;
  invoice_missing_reason: InvoiceMissingReason;
  invoice_missing_number: string | null;
};

type GetSsoTokenResponse = {
  sso_token: string;
};

@Injectable({
  providedIn: 'root'
})
export class SzamlazzhuService {
  private authService = inject(AuthService);
  private redirectTo = inject(RedirectService);
  private usersService = inject(UsersService);
  private router = inject(Router);

  async getKsziInfo(caseId: string): Promise<GetKsziInfoResponse> {
    const url = `${environment.baseUrl}/api/kszi/info/${caseId}`;
    const result = await axios.get<GetKsziInfoResponse>(url);
    return result.data;
  }

  async authenticate(ssotoken: string): Promise<void> {
    const url = `${environment.baseUrl}/api/auth/szamlazzhu/login-with-sso-token`;
    await axios.post(url, { ssotoken });

    this.authService.setOrigin('PLUGIN_SZAMLAZZHU');
    await this.usersService.setUser();
    await this.router.navigateByUrl(environment.afterLoginPath);
  }

  async redirectToSzamlazzhuLogin(): Promise<void> {
    const ssotoken = await this.getSsoToken();

    const url = new URL(`${environment.szamlazzhu.url}/szamla/`);
    url.searchParams.set('action', 'ssologin');

    this.redirectTo.post({ ssotoken }, url.toString());
  }

  /**
 * According the Szamlazzhu terminology it means: get an SSO token from szamlazzhu to start login process.
 * SSO token is a short term key, with this token (and with APP_KEY) can you initialize the login.
 */
  private async getSsoToken(): Promise<string> {
    const url = `${environment.baseUrl}/api/auth/szamlazzhu/get-sso-token`;
    const result = await axios.get<GetSsoTokenResponse>(url);
    return result.data.sso_token;
  }
}
